import React, { type FC } from 'react';

import { getTranslation } from '@confluence/i18n/entry-points/translation.ts';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { type FullPageEditorPresetAPI } from '@confluence/full-page-editor-store';
import { READ_TIME_SEGMENT_KEY } from '@confluence/browser-metrics/entry-points/metric-keys.ts';

import { EditorReadTime } from './EditorReadTime.tsx';
import { OriginalReadTime } from './OriginalReadTime.tsx';
import type { useReadTime_content$key } from './hooks/__generated__/useReadTime_content.graphql.ts';

type ReadTimeProps = {
	contentId: string;
	editorApi?: FullPageEditorPresetAPI | null;
	isInEditor?: boolean;
	isAbbreviatedReadTime?: boolean;
	isDetailsPanel?: boolean;
	showWordCount?: boolean;
	contentFragmentRef?: useReadTime_content$key | null;
};

export const ReadTime: FC<ReadTimeProps> = ({
	contentId,
	editorApi,
	isInEditor,
	isAbbreviatedReadTime,
	isDetailsPanel,
	showWordCount,
	contentFragmentRef,
}) => {
	const { locale } = getTranslation();
	const shouldRenderReadTime = locale && locale.substring(0, 2).toLowerCase() === 'en';

	if (!shouldRenderReadTime) {
		return null;
	}

	return (
		<>
			<PageSegmentLoadStart metricKey={READ_TIME_SEGMENT_KEY} />
			{isInEditor ? (
				<EditorReadTime
					contentId={contentId}
					editorApi={editorApi}
					showWordCount={showWordCount}
					isDetailsPanel={isDetailsPanel}
					isAbbreviatedReadTime={isAbbreviatedReadTime}
				/>
			) : (
				<OriginalReadTime
					contentId={contentId}
					isAbbreviatedReadTime={isAbbreviatedReadTime}
					isDetailsPanel={isDetailsPanel}
					showWordCount={showWordCount}
					contentFragmentRef={contentFragmentRef}
				/>
			)}
		</>
	);
};
